module.exports = __webpack_public_path__ + "static/img/glasses_02.2f9cd7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/glasses_02.png
// module id = 41zi
// module chunks = 0